import type {DaoChannel} from "../../daos/dao-channel.ts";
import {app, onair} from "../../modules/config.ts";
import * as React from "react";
import {useState} from "react";
import {Api} from "../../modules/api.ts";
import type {ApiResponse} from "../../modules/interfaces.ts";
import type {DaoApiFavorite} from "../../daos/dao-api-favorite.ts";
import _ from "lodash";
import {useAppDispatch} from "../../stores/hook.ts";
import {askAlert, askConfirm} from "../../stores/dialog.thunk.ts";
import {Utils} from "../../modules/utils.ts";

interface ChannelProps {
  channel: DaoChannel,
  listenCallback?: (channel: DaoChannel) => void,
  favoriteCallback?: (channel: DaoChannel) => void,
}

function Channel({channel, listenCallback, favoriteCallback}: ChannelProps) {
  const dispatch = useAppDispatch();
  const [daoChannel, setDaoChannel] = useState<DaoChannel>(channel);


  async function listenHandler(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    if(!_.isEqual(String(daoChannel.no), String(onair.options?.channel))) {
      if(_.isFunction(listenCallback)) {
        const isConfirmed = await dispatch(askConfirm('', `"${daoChannel.name}" 채널을 재생하시겠습니까?`));
        if (isConfirmed) {
          listenCallback.call(null, daoChannel);
        }
      }
    }
  }

  async function favoriteHandler(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    const new_favorite: number = daoChannel.favorite === 1 ? 0 : 1;
    const rs: ApiResponse<DaoApiFavorite> = await Api.favorite(daoChannel.no, new_favorite);
    const daoApiFavorite = rs.data as DaoApiFavorite;
    if (daoApiFavorite?.rs === 1) {
      setDaoChannel((prev: DaoChannel) => ({
        ...prev,
        favorite: new_favorite
      } as DaoChannel));

      await dispatch(askAlert('', `"${daoChannel.name}" 채널을 즐겨찾기${new_favorite ? '에 추가' : '에서 제거'}하였습니다.`));
      if(_.isFunction(favoriteCallback)) {
        favoriteCallback.call(null, daoChannel);
      }
    }
  }

  return (
    <article className="channel-item" onClick={listenHandler}>
      <figure className="image">
        <img src={`${app.getCover(daoChannel.cover)}`} alt="" onError={(e) => {
          e.currentTarget.src = app.image_default;
        }}/>
        <span className="favorite-wrap" onClick={favoriteHandler}><button
          className={`bookmark-btn ${Number(daoChannel.favorite) === 1 ? 'active' : ''}`}
          aria-label="즐겨찾기1"></button></span>
      </figure>
      <div className="channel-text">
        <div className="channel-title">{daoChannel.name}</div>
        <div className="channel-desc">{daoChannel.description}</div>

        {import.meta.env.MODE === 'development' && (
          <div style={{fontSize: '10px', color: '#999'}}>{daoChannel.counts} / {Utils.duration(daoChannel.duration, false)}</div>
        )}
      </div>
    </article>
  );
}

export default Channel;